export enum WorkoutActionNames {
  'LOAD_WORKOUT_PREVIEWS' = '[WORKOUTS] LOAD_WORKOUT_PREVIEWS',
  'LOAD_WORKOUT_PREVIEWS_SUCCESS' = '[WORKOUTS] LOAD_WORKOUT_PREVIEWS_SUCCESS',
  'LOAD_WORKOUT_PREVIEWS_FAILURE' = '[WORKOUTS] LOAD_WORKOUT_PREVIEWS_FAILURE',
  'CLEAN_WORKOUT_PREVIEWS' = '[WORKOUTS] CLEAN_WORKOUT_PREVIEWS',

  'LOAD_WORKOUT_DETAILS' = '[WORKOUTS] LOAD_WORKOUT_DETAILS',
  'LOAD_WORKOUT_DETAILS_SUCCESS' = '[WORKOUTS] LOAD_WORKOUT_DETAILS_SUCCESS',
  'LOAD_WORKOUT_DETAILS_FAILURE' = '[WORKOUTS] LOAD_WORKOUT_DETAILS_FAILURE',
  'CLEAN_WORKOUT_DETAILS' = '[WORKOUTS] CLEAN_WORKOUT_DETAILS',

  'CREATE_WORKOUT' = '[WORKOUTS] CREATE_WORKOUT',
  'CREATE_WORKOUT_SUCCESS' = '[WORKOUTS] CREATE_WORKOUT_SUCCESS',
  'CREATE_WORKOUT_FAILURE' = '[WORKOUTS] CREATE_WORKOUT_FAILURE',

  'EDIT_WORKOUT' = '[WORKOUTS] EDIT_WORKOUT',
  'EDIT_WORKOUT_SUCCESS' = '[WORKOUTS] EDIT_WORKOUT_SUCCESS',
  'EDIT_WORKOUT_FAILURE' = '[WORKOUTS] EDIT_WORKOUT_FAILURE',

  'DELETE_WORKOUT' = '[WORKOUTS] DELETE_WORKOUT',
  'DELETE_WORKOUT_SUCCESS' = '[WORKOUTS] DELETE_WORKOUT_SUCCESS',
  'DELETE_WORKOUT_FAILURE' = '[WORKOUTS] DELETE_WORKOUT_FAILURE',

  'NAVIGATED_FROM_WORKOUT_COMPOSE' = '[WORKOUTS] NAVIGATED_FROM_WORKOUT_COMPOSE',
  'NAVIGATED_FROM_WORKOUT_DISPLAY' = '[WORKOUTS] NAVIGATED_FROM_WORKOUT_DISPLAY',
}
